const initState = {
  isLoaderVerificar: false,
  isLoaderOferta: false
};

export default initState;
